import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { AgentPersonnelSummaryGetCollection, AgentPersonnelSummaryGetCollectionResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<AgentPersonnelSummaryGetCollectionResponse, AgentPersonnelSummaryGetCollectionResponse>) => {
    return response?.data?.agentPersonnelSummaries
}
const getError = (response?: SWRResponse<AgentPersonnelSummaryGetCollectionResponse, AgentPersonnelSummaryGetCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const useAgentPersonnelSummaries = (configuration?: SWRConfiguration<AgentPersonnelSummaryGetCollectionResponse, AgentPersonnelSummaryGetCollectionResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new AgentPersonnelSummaryGetCollection();
        };
    }, [])

    return useGet(request, { getData, getError }, configuration);
}

export default useAgentPersonnelSummaries;